export const linkedRowClass =
    'flex items-center gap-2 rounded-lg border border-subtle bg-accent px-3 py-2';

export const linkedChipClass =
    'inline-flex max-w-full items-center gap-1 rounded-sm border border-subtle bg-accent px-2 py-0.5 text-xs font-medium';

export const linkedNameClass = 'min-w-0 flex-1 truncate text-xs font-medium';

export const linkedMetaClass =
    'min-w-0 max-w-[50%] truncate text-[11px] font-medium text-subtle-foreground';
